import { PaymentMethod } from '@/hooks/usePayments'

interface PaymentMethodIconProps {
  method: PaymentMethod | null
  showLabel?: boolean
}

const methodConfig: Record<PaymentMethod, { icon: string; label: string }> = {
  pix: { icon: '💰', label: 'PIX' },
  bank_transfer: { icon: '🏦', label: 'Transferência' },
  cash: { icon: '💵', label: 'Dinheiro' },
  boleto: { icon: '📄', label: 'Boleto' },
  credit_card: { icon: '💳', label: 'Cartão' },
  paypal: { icon: '🌐', label: 'PayPal' },
  other: { icon: '📦', label: 'Outro' },
}

export function PaymentMethodIcon({ method, showLabel = true }: PaymentMethodIconProps) {
  if (!method) return <span className="text-muted-foreground text-sm">-</span>
  
  const config = methodConfig[method]
  
  return (
    <span className="inline-flex items-center gap-1 text-sm">
      <span>{config.icon}</span>
      {showLabel && <span>{config.label}</span>}
    </span>
  )
}
